import React from 'react';

const ExchangePolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden border border-gray-100">
        <div className="p-4 sm:p-12">
          <h1 className="text-3xl sm:text-4xl font-extrabold mb-4 border-b-2 border-gray-200 pb-4">
            Exchange Policy
          </h1>

          {/* Date Added Here */}
          <p className="text-sm text-gray-500 mb-8 italic font-medium">
            Update at 10/01/2026
          </p>
          
          <div className="text-gray-800 space-y-6 leading-relaxed text-base">
            
            {/* Intro Section */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Liberal Exchange Policy – Regees Textile
              </h2>
              <p className="mb-4">
                Customer satisfaction is our top priority at <span className="font-bold">Regees Tex</span>. If you are not fully satisfied with a product purchased through our website, our online support team will assist you with the exchange process.
              </p>
              <p className="mb-4">
                Customers must raise their exchange request by sending an email to 
                <a
                  href="mailto:rtexiles1985@gmail.com?subject=Exchange%20Request&body=Order%20ID:%20"
                  className="font-bold text-black hover:underline"
                >
                rtexiles1985@gmail.com
              </a>.
              </p>
              <p>
                Exchange requests will be accepted <span className="font-bold">only after receiving written confirmation via email</span> from our online team.
              </p>
            </div>

            {/* Conditions Section */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Conditions for Return / Exchange
              </h2>
              <ul className="list-disc pl-5 space-y-2 text-gray-800">
                <li>Products must be unused and in unfolded condition</li>
                <li>Original invoice, tags, and bills must be intact</li>
                <li>
                  Return requests must be initiated within <span className="font-bold">7 days</span> of delivery
                </li>
                <li>
                  Damage, stains, or defects must be reported within <span className="font-bold">24 hours</span> of receipt
                </li>
                <li>Digital images may be requested for verification</li>
                <li>No additional charges shall apply if the issue is due to the Company</li>
              </ul>
            </div>

            {/* International Orders Section */}
            {/* <div>
              <h2 className="text-xl font-bold mb-2">
                International Orders(?)
              </h2>
              <p>
                Returns or exchanges are <span className="font-bold">not accepted</span> for international orders.
              </p>
            </div> */}

            {/* Return Address Section */}
            {/* <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Return Address
              </h2>
              <div className="text-gray-800 leading-relaxed">
                <p>RTEX Retail Clothing Store</p>
                <p>Main market road, Pattukkottai</p>
                <p>Tamil Nadu, 614601</p>
                <p>Mobile: +91 70100 87910</p>
              </div>
            </div> */}

          </div>
        </div>
      </div>
    </div>
  );
};

export default ExchangePolicy;